module.exports = __webpack_public_path__ + "static/media/analytics.911b4568.svg";